<!-- EvaluationTableRow.vue -->
<template>
    <div class="d-flex justify-content-center">

        <!-- <b-button variant="success" class="m-2 text-white" style="min-width: 200px;"
            @click="projectEvaluationTable()">
            Update Score
        </b-button> -->


        <b-modal id="importExcelModel" size="xl" v-model="viewImportExcelModel" title="Import Excel for Scores"
            hide-footer>
            <ProjectExcelImport :importExcelFile="importExcelFile" :excelImportStatus="excelImportStatus"
                @import="importScoreExcel" />
        </b-modal>

        <b-col>
            <div class="d-flex align-items-center justify-content-between mb-3">
                <div class="d-flex align-items-center">
                    <!-- EDIT ICON -->
                    <i class="fas fa-edit text-info ml-2" style="font-size: 15px!important;cursor: pointer;"
                        v-if="!isEditMode" variant="outline-primary" @click="enableEditMode"></i>
                    <!-- IMPORT EXCEL -->
                    <b-button v-if="isEditMode" variant="primary" class="mr-2" v-b-modal.importExcelModel>
                        Import Excel
                    </b-button>

                    <!-- SAVE -->
                    <b-button v-if="isEditMode" variant="success" class="mr-2" @click="updateProjectEvaluation">
                        Save
                    </b-button>

                    <!-- CANCEL -->
                    <b-button v-if="isEditMode" variant="danger" @click="cancelEdit">
                        Cancel
                    </b-button>
                </div>

                <!-- DOWNLOAD PDF -->
                <b-button v-if="!isEditMode" variant="danger" size="sm" @click="downloadPdf"
                    :disabled="pdfDownloading">
                    {{ pdfDownloading ? 'Downloading...' : 'Download Report' }}
                </b-button>
            </div>

            <table class="table table-striped table-bordered">
                <thead style="position: sticky; top: 0; background-color: gray;">
                    <tr>
                        <th rowspan="3">{{ studentListOrder === 'enrollment_no' ? 'Enrollment No.' : studentListOrder === 'admission_number' ? 'Admission No.' : studentListOrder === 'register_number' ? 'Register No.' : 'Roll No.' }}</th>
                        <th rowspan="3">Student</th>
                        <th v-for="(method, methodIndex) in evaluationMethods" :key="methodIndex"
                            :colspan="method.parameters.length">
                            <span v-b-tooltip.hover :title="method.name">{{ method.name }}</span>
                        </th>
                        <th rowspan="3">Total Score ({{ totalMaxScore }})</th>
                        <!-- <th rowspan="3">Avg</th> -->
                    </tr>
                    <tr>
                        <th v-for="(parameter, paramIndex) in evaluationTableHeaderRow" :key="paramIndex">
                            {{ parameter.short_code || parameter.name}} ({{ parameter.max_score }})
                        </th>
                    </tr>
                    <tr>
                        <th v-for="(parameter, paramIndex) in evaluationTableHeaderRow" :key="paramIndex">
                            {{ Array.isArray(parameter.cos) ? parameter.cos.join(', ') : parameter.cos }}
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(student, studIndex) in students" :key="studIndex">
                        <th class="fixed-table-column">{{ studentListOrder === 'enrollment_no' ? student.enrollment_no : studentListOrder === 'admission_number' ? student.admission_no : studentListOrder === 'register_number' ? student.register_no : student.roll_number }}</th>
                        <th class="fixed-table-column">{{ student.first_name }} {{ student.last_name }}</th>
                        <td v-for="(evaluationHeader, headIndex) in evaluationTableHeaderRow" :key="headIndex"
                            style="min-width: 60px;">
                            <b-form-input :disabled="!isEditMode"
                                v-model="evaluationTableData[student.institution_user_id][evaluationHeader.project_method_id][evaluationHeader.id]"
                                type="number" :max="evaluationHeader.max_score" placeholder="Enter score"
                                @focus="handleScoreInputFocus(student.institution_user_id, evaluationHeader.project_method_id, evaluationHeader.id)"
                                @input="updateTotalMarks(student.institution_user_id, evaluationHeader.project_method_id)">
                            </b-form-input>
                        </td>
                        <td>
                            {{ totalOfAllProjects[student.institution_user_id] || 0 }}
                        </td>
                        <!-- <th class="fixed-table-column">
                            {{ avarage[student.institution_user_id]
                                    ? Number(avarage[student.institution_user_id]).toFixed(2)
                                    : 0
                            }}
                        </th> -->
                    </tr>
                </tbody>
            </table>

            <div v-for="(method, methodIndex) in evaluationMethods" :key="methodIndex">
                <ul>
                    <li v-for="(parameter, paramIndex) in method.parameters" :key="paramIndex">
                        {{ parameter.short_code }} - {{ parameter.name }}
                    </li>
                </ul>
            </div>

            <div v-if="isEditMode" class="d-flex align-items-center mb-3">
                <b-button variant="success" class="mr-2" @click="updateProjectEvaluation">
                    Save
                </b-button>
                <b-button variant="danger" @click="cancelEdit">
                    Cancel
                </b-button>
            </div>
        </b-col>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from "axios";
import ProjectExcelImport from './ProjectExcelImport.vue';
import readXlsxFile from "read-excel-file";

export default {
    async created() {
        await this.fetchProjectMethods();
        await this.projectEvaluationTable();
    },

    props: {
        methodId: {
            type: Number
        },
        course_id: { type: Number, required: true },
        project_role_id: { type: Number }
    },
    components: {
        ProjectExcelImport
    },

    data() {
        return {
            isEditMode: false,
            originalData: null,
            viewImportExcelModel: false,
            importExcelFile: null,
            excelImportStatus: "",
            evaluationMethods: [],
            evaluationTableHeaderRow: [],
            evaluationTableData: {},
            students: [],
      studentListOrder: 'roll_number',
            totalScores: {},
            avarage: {},
            totalOfAllProjects: {},
            totalMaxScore: 0,
            updateProjectEvaluationButton: "Save",
            scoreEntryCount: new Set(),
            autoUpdation: false,
            pdfDownloading: false,
        };
    },

    methods: {

        enableEditMode() {
            this.isEditMode = true;
            this.originalData = JSON.parse(JSON.stringify(this.evaluationTableData));
        },

        cancelEdit() {
            this.isEditMode = false;
            this.evaluationTableData = JSON.parse(JSON.stringify(this.originalData));
            this.$toast.info("Edit cancelled", { position: "top", duration: 2000 });
        },

        async fetchProjectMethods() {
            const url = `${this.$store.getters.getAPIKey.mainAPI}/projectmethods?course_id=${this.course_id}`;

            try {
                const response = await axios.get(url);

                this.evaluationMethods = response.data
                    .filter(method => method.id === this.methodId)
                    .map(method => ({
                        id: method.id,
                        name: method.name,
                        parameters: method.project_parameters ?? [],
                    }));

            } catch (error) {
                console.error(error);
            }
        },

        async importScoreExcel(event) {
            this.excelImportStatus = "Importing in progress...";
            try {
                // Read Excel file content
                const excelData = await readXlsxFile(event.target.files[0]);
                // Validate file content
                if (!excelData || excelData.length === 0) {
                    throw new Error("The Excel file is empty.");
                }
                if (excelData.length > this.students.length) {
                    throw new Error(
                        `The Excel file contains more rows (${excelData.length}) than the number of students (${this.students.length}).`
                    );
                }
                const baseColumns = this.evaluationTableHeaderRow.length;
                const numMethods = this.evaluationMethods.length;
                // Users may leave the (now unused, auto-calculated) Total column from the
                // old template in place for each method — tolerate one extra trailing
                // column per method block and simply skip it during import.
                const withTotalsColumns = baseColumns + numMethods;
                if (excelData.some(row => row.length !== baseColumns && row.length !== withTotalsColumns)) {
                    throw new Error(
                        `The column count in the Excel file does not match the expected count (${baseColumns}).`
                    );
                }
                const hasTotalColumns = excelData[0].length === withTotalsColumns;

                // Process each row and map it to the Vue table structure
                excelData.forEach((row, rowIndex) => {
                    const student = this.students[rowIndex];
                    let colIndex = 0;
                    let headerIndex = 0;
                    this.evaluationMethods.forEach((method) => {
                        method.parameters.forEach(() => {
                            const header = this.evaluationTableHeaderRow[headerIndex];
                            const excelValue = row[colIndex];
                            if (isNaN(excelValue)) {
                                throw new Error(`Invalid score at Row ${rowIndex + 1}, Column ${colIndex + 1}.`);
                            }
                            this.handleScoreValue(excelValue, student.institution_user_id, header.project_method_id, header.id);
                            colIndex++;
                            headerIndex++;
                        });
                        if (hasTotalColumns) {
                            colIndex++; // Skip the unused Total column for this method.
                        }
                    });
                });
                // Display success message
                this.$toast.success("Project scores and dates imported successfully!", {
                    position: "top",
                    duration: 5000,
                });
                this.excelImportStatus = "Import completed successfully.";
            } catch (error) {
                // Display error message
                this.$toast.error(`Error: ${error.message}`, {
                    position: "top",
                    duration: 10000,
                });
                this.excelImportStatus = "Import failed.";
            } finally {
                // Reset file input and status
                this.excelImportStatus = "";
                this.importExcelFile = null;
                this.viewImportExcelModel = false;
            }
        },
        // Helper function to handle score values
        handleScoreValue(excelValue, institution_user_id, project_method_id, headerId) {
            this.$set(
                this.evaluationTableData[institution_user_id][project_method_id],
                headerId,
                parseFloat(excelValue)
            );
            this.updateTotalMarks(institution_user_id, project_method_id);
        },
        async fetchCourseStudents() {
            const url = this.$store.getters.getAPIKey.createStudent.replace("course_id", this.course_id) + '?sortBy=project';
            const response = await this.$axios.get(url);
            this.students = response.data.users ?? response.data[0] ?? [];
            this.studentListOrder = response.data.student_list_order || 'roll_number';
        },

        async projectEvaluationTable() {
            this.evaluationTableHeaderRow = [];

            if (this.students.length === 0) await this.fetchCourseStudents();

            let totalMax = 0;
            this.evaluationMethods.forEach((method) => {
                method.parameters.forEach((parameter) => {
                    totalMax += Number(parameter.maximum_score);
                    this.evaluationTableHeaderRow.push({
                        id: parameter.id,
                        name: parameter.name,
                        short_code: parameter.short_code,
                        project_method_id: method.id,
                        max_score: parameter.maximum_score,
                        cos: parameter.co_codes,
                    });
                });
            });
            this.totalMaxScore = totalMax;

            this.students.forEach((student) => {
                Vue.set(this.evaluationTableData, student.institution_user_id, {});
                Vue.set(this.totalScores, student.institution_user_id, {});
                Vue.set(this.avarage, student.institution_user_id, {});

                this.evaluationTableHeaderRow.forEach((header) => {
                    if (!this.evaluationTableData[student.institution_user_id][header.project_method_id]) {
                        Vue.set(this.evaluationTableData[student.institution_user_id], header.project_method_id, {});
                    }
                    Vue.set(this.evaluationTableData[student.institution_user_id][header.project_method_id], header.id, null);
                });
            });

            // this.$bvModal.show("projectEvaluationModel");

            const url = `${this.$store.getters.getAPIKey.mainAPI}/projectevaluations/updateScore?
            course_id=${this.course_id}&project_role_id=${this.project_role_id}`;
            const response = await axios.get(url);

            response.data.forEach((evaluation) => {
                const studentId = evaluation.student_id;
                const methodId = evaluation.parameter.project_method_id;
                const parameterId = evaluation.project_parameter_id;

                // student row must exist
                if (!this.evaluationTableData[studentId]) return;

                // method may not exist (filtered methods!)
                if (!this.evaluationTableData[studentId][methodId]) {
                    return;
                }

                // Vue-safe set
                Vue.set(
                    this.evaluationTableData[studentId][methodId],
                    parameterId,
                    parseFloat(evaluation.score)
                );

                this.updateTotalMarks(studentId, methodId);
            });


            this.$forceUpdate();
        },

        updateTotalMarks(student_id, project_method_id) {
            const scores = this.evaluationTableData[student_id][project_method_id];
            const total = Object.values(scores).reduce((sum, score) => sum + Number(score || 0), 0);
            this.totalScores[student_id][project_method_id] = total;

            // Calculate total of all project totals
            const allTotals = Object.values(this.totalScores[student_id]).filter(score => score);
            const totalOfAllProjects = allTotals.reduce((a, b) => a + b, 0);
            this.totalOfAllProjects[student_id] = totalOfAllProjects;

            // Calculate average
            this.avarage[student_id] = allTotals.length
                ? (totalOfAllProjects / allTotals.length).toFixed(2)
                : 0;
        },

        async handleScoreInputFocus(student_id, project_method_id, parameter_id) {
            const key = `${student_id}-${project_method_id}-${parameter_id}`;
            this.scoreEntryCount.add(key);

            if (this.scoreEntryCount.size == 20) {
                this.autoUpdation = true;
                await this.updateProjectEvaluation();
            }
        },

        async downloadPdf() {
            this.pdfDownloading = true;
            try {
                const response = await axios.post(
                    `${this.$store.getters.getAPIKey.mainAPI}/projectevaluations/role-method/report/pdfexport`,
                    {
                        course_id: this.course_id,
                        project_method_id: this.methodId,
                        project_role_id: this.project_role_id,
                        user_id: this.$store.getters.getDefaultInstituteUserId,
                    },
                    { responseType: 'blob' }
                );

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'project_evaluation.pdf');
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            } catch (error) {
                this.$toast.error("Failed to download PDF", { position: "top", duration: 3000 });
            } finally {
                this.pdfDownloading = false;
            }
        },

        closeProjectEvaluationModel() {
            this.$bvModal.hide("projectEvaluationModel");
        },

        async updateProjectEvaluation() {
            const postData = [];

            Object.entries(this.evaluationTableData).forEach(([student_id, methods]) => {
                Object.entries(methods).forEach(([project_method_id, parameters]) => {
                    Object.entries(parameters).forEach(([project_parameter_id, score]) => {
                        if (score !== null) {
                            postData.push({
                                score,
                                course_id: this.course_id,
                                project_role_id: this.project_role_id,
                                student_id,
                                project_method_id,
                                project_parameter_id,
                            });
                        }
                    });
                });
            });

            try {
                await axios.post(
                    `${this.$store.getters.getAPIKey.mainAPI}/projectevaluations/updateScore`,
                    { projectEvaluations: postData }
                );
                if (this.autoUpdation) {
                    this.scoreEntryCount.clear();
                    this.$toast.success("Automatically updated successfully.", {
                        position: "top",
                        duration: 3000
                    });
                    this.autoUpdation = false;
                } else {
                    this.isEditMode = false;
                    this.$toast.success("Successfully Updated", {
                        position: "top",
                        duration: 3000
                    });
                }

            } catch (error) {
                this.$toast.error("Failed to update", { position: "top", duration: 3000 });
                error;
            }
        },
    },
};
</script>
<style>
.projectEvaluation .modal-dialog {
    max-width: 100%;
    max-height: 100vh;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    position: fixed;
    z-index: 100000;
}

.projectEvaluation .modal-body {
    overflow: scroll;
}

.projectEvaluation .fixed-table-column {
    position: sticky;
    left: 0;
    background-color: gray;
}
</style>
